import client from '../lib/http-client';
import { buildQuery } from '../lib/helper';

const endpoint = '/users';

export default {
	// Reset Password
	resetPassword(email, cb, errorCb) {
		const params = {
			email,
		};
		const url = `${endpoint}/password/reset`;
		client.post(url, params)
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Set Password
	setPassword(params, cb, errorCb) {
		const url = `${endpoint}/password/reset/create`;
		client.post(url, params)
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Validate Reset Password Code
	validateResetPasswordCode(params, cb, errorCb) {
		const url = `${endpoint}/password/reset/validate`;
		client.post(url, params)
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Change Password
	changePassword(currentPassword, newPassword, cb, errorCb) {
		const params = {
			current_password: currentPassword,
			new_password: newPassword,
		};
		const url = `${endpoint}/password`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Create User
	create(params, cb, errorCb) {
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		const url = `${endpoint}`;
		client.post(url, params)
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Create Bulk
	createBulk(users, cb, errorCb) {
		const url = `${endpoint}/bulk/create`;
		const params = { users: JSON.stringify(users) };
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.post(url, params)
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Get
	get(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url)
			.then(responseHandler)
			.catch(errorHandler);
	},

	/**
	 * Search
	 *
	 * @param {string} role Role
	 * @param {object} params Params
	 * @param {number} params.page Page
	 * @param {number} params.limit Limit
	 * @param {string} params.role Role
	 * @param {string} params.keyword Keyword
	 * @param {*} cb Callback
	 * @param {*} errorCb Error Callback
	 */
	search(params, cb, errorCb) {
		const url = `${endpoint}/search`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url, { params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	/**
	 * Search with Role
	 *
	 * @param {string} role Role
	 * @param {object} params Params
	 * @param {number} params.page Page
	 * @param {number} params.limit Limit
	 * @param {string} params.keyword Keyword
	 * @param {*} cb Callback
	 * @param {*} errorCb Error Callback
	 */
	searchWithRole(role, params, cb, errorCb) {
		const url = `${endpoint}/search/${role}`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url, { params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Get Users
	getUsers(params, cb, errorCb) {
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		const url = endpoint;
		client.get(url, { params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	/**
	 * Get Users by Role
	 *
	 * @param {'admin' | 'teacher' | 'student'} role User Role
	 * @param {Object} params Query Params
	 * @param {*} cb
	 * @param {*} errorCb
	 */
	getUsersByRole(role, params, cb, errorCb) {
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		// const query = buildQuery(params);
		// const url = `${endpoint}/role/${role}?${query}`;
		const url = `${endpoint}/role/${role}`;
		client.get(url, { params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Bulk Delete
	bulkDelete(ids, cb, errorCb) {
		const params = {
			user_ids: JSON.stringify(ids),
			is_deleted: 1,
		};
		const url = `${endpoint}`;
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		client.delete(url, { data: params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Update user
	update(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Delete user
	// delete(id, params, cb, errorCb) {
	// 	const url = `${endpoint}/${id}`;
	// 	client.delete(url, params)
	// 		.then((response) => {
	// 			if (cb) cb(response.data);
	// 		})
	// 		.catch((e) => {
	// 			if (errorCb) errorCb(e);
	// 		});
	// },
	delete(id, params, cb, errorCb) {
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		const url = `${endpoint}/${id}`;
		client.delete(url, { params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Update user password
	updatePassword(params, cb, errorCb) {
		const url = `${endpoint}/${params.id}/password`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Set First Time Login
	setLogin(cb, errorCb) {
		const url = `${endpoint}/firstLogin`;
		client.post(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	getStatistics(cb, errorCb) {
		const url = `${endpoint}/statistics`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	exportList(type, params, cb, errorCb) {
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		const query = buildQuery(params);
		const url = `${endpoint}/export/${type}?${query}`;
		client.get(url, { responseType: 'blob' })
			.then(responseHandler)
			.catch(errorHandler);
	},
	// Change Password
	forceUpdatePassword(id, password, cb, errorCb) {
		const url = `${endpoint}/force_update_password/${id}`;
		client.put(url, password)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},
	changePaymentMethod(params, cb, errorCb) {
		const url = `${endpoint}/payment/change`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},
	// eslint-disable-next-line
	myStatistics(start_date, end_date, user_id, cb, errorCb) {
		// eslint-disable-next-line
		const url = `${endpoint}/statistics?start_date=${start_date}&end_date=${end_date}&user_id=${user_id}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Update limit
	updateLimit(params, cb, errorCb) {
		const url = `${endpoint}/additional`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Users integration Frill
	frillToken(cb, errorCb) {
		const url = `${endpoint}/integration/frill`;
		client.post(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
